export const getIndexThatIncludesInsertZones = (index: number): number => {
  return index * 2 + 1;
};
